import { BoxItem } from 'box-ui-elements/es';

export const ATTACHMENTS_SIZE_LIMIT_MB = 24;
const ATTACHMENTS_SIZE_LIMIT_BYTES = ATTACHMENTS_SIZE_LIMIT_MB * 1000000;

export function isTotalAttachmentsSizeReached(attachedFiles: BoxItem[]) {
  const attachmentsTotalSize = attachedFiles.reduce((totalSize, file) => totalSize + file.size, 0);
  return attachmentsTotalSize > ATTACHMENTS_SIZE_LIMIT_BYTES;
}
